export default __webpack_public_path__ + "static/media/maindelete.8ac32641.svg";